export enum Direction {
    In = "In",
    Out = "Out"
}
